import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

import { CBMError, VildVersion } from 'app/models';
import { TaskService } from 'app/services';

@Component({
  selector: 'app-dialog-vild-encode',
  templateUrl: './dialog-vild-encode.component.html'
})
export class DialogVildEncodeComponent {
  @ViewChild('confirmStartVildEncodingDialog') confirmStartVildEncodingDialog: ModalDirective;

  @Output() onConfirm = new EventEmitter<boolean>();
  @Input() vildVersion: VildVersion;

  private readonly modalTimeout = 2000;

  public isEncodingVild = false;
  public vildVersionIsSuccesfullyEncoded = false;
  public encodeVildErrorMessages: CBMError[] = [];

  constructor(private readonly taskService: TaskService) {}

  public show(): void {
    this.confirmStartVildEncodingDialog.show();
  }

  public stopStartVildEncoding(): void {
    this.confirmStartVildEncodingDialog.hide();
  }

  public startVildEncoding(): void {
    this.isEncodingVild = true;
    this.encodeVildErrorMessages = [];

    if (this.isEncodingVild) {
      this.taskService.startEncodeVildTask(this.vildVersion.id).subscribe(
        () => {
          this.vildVersionIsSuccesfullyEncoded = true;

          setTimeout(() => {
            this.isEncodingVild = false;
            this.onConfirm.emit(true);
            this.confirmStartVildEncodingDialog.hide();
          }, this.modalTimeout);
        },
        error => {
          this.isEncodingVild = false;

          if (error instanceof CBMError) {
            this.encodeVildErrorMessages.push(error);
          } else if (error instanceof Array) {
            this.encodeVildErrorMessages = error;
          }
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-vild-encode/dialog-vild-encode.component.ts